import React, { useState, useEffect } from "react";
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import {
  Box,
  Typography,
  Pagination,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { toMoney } from "../util/Utils";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import useBreakpoints from "../hooks/useBreakpoints";

export default function CustomPagination(props) {
  const apiRef = useGridApiContext();
  const [value, setValue] = useState();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.scrollTo) {
      setTimeout(function () {
        apiRef.current.scroll(props.scrollTo);
      }, 900);
    } else {
      setTimeout(function () {
        apiRef.current.scroll({
          top: 0,
          left: props.isLtr ? window.innerWidth + 2000 : 0,
        });
      }, 200);
    }
  }, [props.scrollTo]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        zIndex: 1,
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {props.rowCount &&
          props.rowCount !== 0 &&
          props.rowCount !== "" &&
          props.showMoreConsultant &&
          props.hasMore && (
            <Button
              color="secondary"
              // variant="out"
              sx={{ visibility: "hidden" }}
              onClick={() => {
                props.newFunc();
              }}
            >
              نمایش بیشتر
            </Button>
          )}
        {props.nofab ? (
          ""
        ) : isSmall ? (
          <Fab
            sx={{ ml: 1 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            onClick={() => {
              props.newFunc();
            }}
          >
            <AddIcon />
          </Fab>
        ) : (
          <Fab
            sx={{ ml: 1 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            onClick={() => {
              props.newFunc();
            }}
          >
            <AddIcon />
            جدید
          </Fab>
        )}

        {props.creatLogestic && (
          <Fab
            sx={{ ml: 1 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            onClick={() => {
              props.newFunc();
            }}
          >
            <AddIcon />
            ایجاد
          </Fab>
        )}

        {!props.newFuncRotate ? (
          ""
        ) : (
          <Fab
            sx={{ ml: 1 }}
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            onClick={() => {
              props.newFuncRotate();
            }}
          >
            <AutorenewIcon />
            چرخش
          </Fab>
        )}
        {props.print && (
          <Fab
            sx={{ px: 3, ml: 2 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            onClick={() => {
              props.printProducts();
            }}
          >
            چاپ
          </Fab>
        )}
        {props.showMore && (
          <Fab
            sx={{ px: 2, ml: 2 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
          >
            <Link
              target="_blank"
              to={{
                pathname: `/orders?state=1`,
                hash: props.mobile,
              }}
            >
              <IconButton sx={{ fontSize: ".8rem", color: "#fff" }}>
                نمایش کامل
              </IconButton>
            </Link>
          </Fab>
        )}
        {props.showLess && (
          <Fab
            sx={{ px: 2, ml: 2 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            onClick={() => {
              props.callBack2();
            }}
          >
            عدم نمایش کامل
          </Fab>
        )}
        {props.ChildGroup && (
          <Fab
            sx={{ ml: 1 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            onClick={() => {
              props.ChildGroup();
            }}
          >
            <AddIcon />
            زیر گروه جدید
          </Fab>
        )}
        {props.newGroup && (
          <Fab
            sx={{ ml: 1 }}
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            onClick={() => {
              props.newGroup();
            }}
          >
            <AddIcon />
            گروه جدید
          </Fab>
        )}
      </Box>
      {props.noPage ? (
        ""
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            justifySelf: "center",
            mx: "auto",
          }}
        >
          {isSmall ? (
            ""
          ) : (
            <Typography variant="body2">
              صفحه {page + 1} از {pageCount ? pageCount : 1}
            </Typography>
          )}
          <Pagination
            sx={{ ml: 1 }}
            color="secondary"
            count={pageCount ? pageCount : 1}
            page={page + 1}
            onChange={(event, value) => {
              setValue("");
              apiRef.current.setPage(value - 1);
            }}
          />
          {props.noPageCount ? (
            ""
          ) : (
            <TextField
              size="small"
              id="outlined-basic"
              value={value ? value : ""}
              placeholder="صفحه"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                inputProps: {
                  min: 1,
                },
              }}
              // type="text"
              onKeyDown={(e) => {
                exceptThisSymbols.includes(e.key) && e.preventDefault();
                if (e.key === "Enter") {
                  apiRef.current.setPage(value - 1);
                }
              }}
              onChange={(event, value) => {
                if (event.target.value) {
                  const sanitizedValue = event.target.value.replace(
                    /[^0-9.]/g,
                    ""
                  );
                  setValue(sanitizedValue);
                } else {
                  apiRef.current.setPage(0);
                  setValue();
                }
              }}
              sx={{ width: "14%", input: { p: "5px", textAlign: "center" } }}
            />
          )}
        </Box>
      )}
      {props.rowCount &&
        props.rowCount !== 0 &&
        props.rowCount !== "" &&
        props.showMoreConsultant &&
        props.hasMore && (
          <Button
            color="secondary"
            // variant="out"
            onClick={() => {
              props.newFunc();
            }}
          >
            نمایش بیشتر
          </Button>
        )}

      <Box sx={{ display: "flex", alignItems: "center" }}>
        {props.CreateSMS && (
          <Button
            sx={{ mx: 1 }}
            variant="contained"
            onClick={() => {
              props.newFunc();
            }}
          >
            ایجاد SMS
          </Button>
        )}
        {props.isMagItems && (
          <Fab
            sx={{ mx: 1 }}
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            onClick={() => {
              props.funcRefList();
            }}
          >
            به‌روزرسانی مقالات
          </Fab>
        )}
        {props.isRefresh && (
          <Box>
            <Fab
              sx={{}}
              variant="extended"
              size="small"
              color="primary"
              aria-label="add"
              onClick={() => {
                props.funcRefList();
              }}
            >
              بروزرسانی محصولات
            </Fab>
            <Fab
              sx={{ mx: 1 }}
              variant="extended"
              size="small"
              color="secondary"
              aria-label="add"
              onClick={() => {
                props.funcRefData();
              }}
            >
              بروزرسانی اطلاعات محصول
            </Fab>
          </Box>
        )}
        {props.logesticButtons && (
          <Box>
            <Fab
              disabled={props.pickup}
              sx={{ width: "100px" }}
              variant="extended"
              size="small"
              color="primary"
              aria-label="add"
              onClick={() => {
                props.funcPickup();
              }}
            >
              تحویل
            </Fab>
            <Fab
              disabled={!props.pickup}
              sx={{ width: "100px", mx: 1 }}
              variant="extended"
              size="small"
              color="secondary"
              aria-label="add"
              // onClick={() => {
              //   props.funcPrint();
              // }}
            >
              <Link
                target="_blank"
                to={{
                  pathname: `/motordelivery/OrderPrint`,
                }}
              >
                <IconButton sx={{ fontSize: ".8rem", color: "#fff" }}>
                  پرینت
                </IconButton>
              </Link>
            </Fab>
            <Fab
              disabled={!props.pickup}
              sx={{ width: "100px", mr: 1 }}
              variant="extended"
              size="small"
              color="secondary"
              aria-label="add"
              onClick={() => {
                props.funcFinalApproval();
              }}
            >
              تحویل نهایی
            </Fab>
          </Box>
        )}
        {props.rowCount && props.rowCount !== 0 && props.rowCount !== "" ? (
          <Typography sx={{ mx: 2 }} variant="span">
            {toMoney(props.rowCount)} مورد
          </Typography>
        ) : (
          ""
        )}
      </Box>
    </Box>
  );
}
